import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const SourceTargetStep = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });

  // TODO: [SP-11686] replace placeholder with the Source and Target engagements step
  return (
    <Typography variant="bodyRegular">{t("stepPlaceholder", { name: t("steps.sourceTarget") })}</Typography>
  );
};
